"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Checkbox = void 0;

var _react = _interopRequireDefault(require("react"));

var _ = require("../");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Checkbox = function Checkbox(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange,
      children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_.View, {
    extend: rootCSS
  }, /*#__PURE__*/_react["default"].createElement(_.View, {
    as: "input",
    type: "checkbox",
    value: value,
    onChange: onChange
  }), /*#__PURE__*/_react["default"].createElement(_.View, null, children));
};

exports.Checkbox = Checkbox;
var rootCSS = {
  display: 'flex'
};